module.exports = __webpack_public_path__ + "img/al-quran.adf7ee38.png";